

export default{

	/**
	 * 将日期格式化成指定格式的字符串
	 * @param date 要格式化的日期，不传时默认当前时间，也可以是一个时间戳
	 * @param fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
	 * @returns 返回格式化后的日期字符串
	 */
	formatDate(date, fmt, count){
		date = date == undefined ? new Date() : date;
		date = typeof date == 'number' ? new Date(date) : date;
		fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
		var obj = {
			'y': date.getFullYear(), // 年份，注意必须用getFullYear
			'M': date.getMonth() + 1, // 月份，注意是从0-11
			'd': count && typeof count == 'function' ? count(date.getDate()) : date.getDate(), // 日期
			'q': Math.floor((date.getMonth() + 3) / 3), // 季度
			'w': count && typeof count == 'function' ? count(date.getDay()) : date.getDay(), // 星期，注意是0-6
			'H': date.getHours(), // 24小时制
			'h': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
			'm': date.getMinutes(), // 分钟
			's': date.getSeconds(), // 秒
			'S': date.getMilliseconds() // 毫秒
		};
		var week = ['天', '一', '二', '三', '四', '五', '六'];
		for(var i in obj){
			fmt = fmt.replace(new RegExp(i+'+', 'g'), function(m){
				var val = obj[i] + '';
				if(i == 'w') return (m.length > 2 ? '星期' : '周') + week[val];
				for(var j = 0, len = val.length; j < m.length - len; j++) val = '0' + val;
				return m.length == 1 ? val : val.substring(val.length - m.length);
			});
		}
		return fmt;
	},
	//毫秒转换为时分秒
	formatDuring: function(mss) {
		let days = parseInt(mss / (1000 * 60 * 60 * 24)),
		hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
		minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60)),
		seconds = parseInt((mss % (1000 * 60)) / 1000);
		if(minutes < 10){
			minutes = '0' + minutes;
		}
		if(seconds < 10){
			seconds = '0' + seconds;
		}
		if(days > 0){
			hours = (days * 24 + hours);
		}
		if(hours < 10){
			hours = '0' + hours;
		}
		return hours + ':' + minutes + ':' + seconds;
	},
	//秒转换为时分秒
	formatTime: function(second) {
		let minutes = parseInt(second / 60),
		seconds = parseInt(second % 60);
		
		if(minutes < 10){
			minutes = '0' + minutes;
		}
		if(seconds < 10){
			seconds = '0' + seconds;
		}
		return minutes + ':' + seconds;
	},
	
	// 计算几天后的日期
	addDays: function(setDate, days){
		var d = setDate ? new Date(setDate.replace(/-/g,'/')) : new Date();
		d.setMilliseconds(d.getMilliseconds()+(days * 24 * 60 * 60 * 1000));
		var month=d.getMonth()+1;   
		var day = d.getDate();
		if(month<10){  
			month = "0"+month;  
		}  
		if(day<10){  
			day = "0"+day;  
		}  
		var val = d.getFullYear()+"-"+month+"-"+day;
		var week = ['日', '一', '二', '三', '四', '五', '六'];
		var weekIndex = d.getDay();
		return {
			dateText: val, 
			weekIndex:weekIndex,
			weekText:week[weekIndex],
			dateOb: d
		};  
	},
}




// WEBPACK FOOTER //
// ./src/api/utils.js